export default {
  chuspic: {
    primary: {
      base: "#003B4D",    // Header BG
      darken1: "#003B4D"  // Footer BG
    },
    secondary: {
      base: "#00E7FF"  // Header: Buttons BG
    },
    accent: {
      base: "#FFFFFF", // Header: app buttons text colot
      darken1: "#FFFFFF"  // Footer: social buttons, text color
    },
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  minimalist: {
    primary: {
      base: "#FFFFFF",
      darken1: "#242730"
    },
    secondary: {
      base: "#1B835B"
    },
    accent: {
      base: "#052C3C",
      darken1: "#FFFFFF"
    },
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
}
